import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import PageBanner from '../common/page/PageBanner'
import Alert from '../common/modal/Alert';
import Paginator from '../common/page/Paginator'
import {getPaginatorHelper} from '../common/page/PaginatorHelper'
import Loading from '../common/modal/Loading';
import Confirmation from '../common/modal/Confirmation';
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList';
import UserSelectionList from '../common/selection/UserSelectionList';
import configData from "../../config/config.json";
import axios from "axios";
import { saveAs } from 'file-saver';

import { AlertListTenantAdminComponetName } from '../../redux/actions/alertActions';
import { setSelectedTenantAdminType, AlertListTenantAdminKey, updateAlertListFilters  } from "../../redux/actions/tenantAdminActions";
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";

const componentName = AlertListTenantAdminKey;

const mapStateToProps = state => {

	return {
		sideNavigationOpen: state.sideNavigationReducer,
		paginationPage: state.alertsPaginationTenantAdminReducer,
		alertListFilters: state.alertListFiltersReducer,
		userListFilters: state.userListFiltersReducer,
		role: state.currentUserReducer.role 
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateAlertListFilters: (filters) => dispatch(updateAlertListFilters(filters)),
		setSelectedTenantAdminType: () => dispatch(setSelectedTenantAdminType(componentName))
	}
}

class AlertList extends React.Component {

	state = {
		filteredList: [],
		selectedId: 0,
		selectedAlertName: '',
		statusType: this.props.alertListFilters.statusType ? this.props.alertListFilters.statusType : false,
		filterText: this.props.alertListFilters.filterText ? this.props.alertListFilters.filterText : '',
		emailAddressId: this.props.alertListFilters.emailAddressId ? this.props.alertListFilters.emailAddressId : '',
		emailAddressName: this.props.alertListFilters.emailAddressName ? this.props.alertListFilters.emailAddressName : '',
		phoneNumberId: this.props.alertListFilters.phoneNumberId ? this.props.alertListFilters.phoneNumberId : '',
		phoneNumberName: this.props.alertListFilters.phoneNumberName ? this.props.alertListFilters.phoneNumberName : '',
		userId: this.props.alertListFilters.userId ? this.props.alertListFilters.userId : '',
		userName: this.props.alertListFilters.userName ? this.props.alertListFilters.userName : '',
		status: '',
		showDeleteConfirmationDialog: false,
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		showEmailAddressList: false,
		showPhoneNumberList: false,
		showUserList: false
	}

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleCloseEmailAddressLookup = (selectedId, selectedName) => {
		this.setState({
		  showEmailAddressList: false,
		  emailAddressId: selectedId,
		  emailAddressName: selectedName
		},  function() { this.handleFilter() } );
	}
	
	handleEmailAddressFinderFilterClick = () => {
		this.setState( {
			showEmailAddressList : true
		  });
	}

	handleEmailAddressFinderFilterReset = () => {
		this.setState({ emailAddressId: 0 },  function() { this.handleFilter() } )
	}

	handleClosePhoneNumberLookup = (selectedId, selectedName) => {
		this.setState({
		  showPhoneNumberList: false,
		  phoneNumberId: selectedId,
		  phoneNumberName: selectedName
		},  function() { this.handleFilter() } );
	}
	
	handlePhoneNumberFinderFilterClick = () => {
		this.setState( {
			showPhoneNumberList : true
		  });
	}

	handlePhoneNumberFinderFilterReset = () => {
		this.setState({ phoneNumberId: 0 },  function() { this.handleFilter() } )
	}

	handleCloseUserLookup = (selectedId, selectedName) => {
		this.setState({
		  showUserList: false,
		  userId: selectedId,
		  userName: selectedName
		},  function() { this.handleFilter() } );
	}
	
	handleUserFinderFilterClick = () => {
		this.setState( {
			showUserList : true
		  });
	}

	handleUserFinderFilterReset = () => {
		this.setState({ userId: 0 },  function() { this.handleFilter() } )
	}

	handleTextFilter = (filterText) => {
		this.setState({ filterText: filterText },  function() { this.handleFilter() } )
	}	

	handleTextFilterReset = () => {
		this.setState({ filterText: '' }, function () { this.handleFilter() })
	}

	handleSelectFilter = (filterSelected) => {
		this.setState({ statusType: filterSelected }, function () { this.handleFilter() })
	}

	handleFilter = () => {
		if (this.showLoading() !== true) {
			return;
		}

		let filters = {filterText: this.state.filterText, statusType: this.state.statusType, userId: this.state.userId, emailAddressId: this.state.emailAddressId, phoneNumberId: this.state.phoneNumberId };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alerts", filters, { withCredentials: true })
		.then((response) => {
			this.setState({filteredList: response.data.content.alerts, status: '' })
			this.props.updateAlertListFilters(filters);
		}, (error) => {
			this.setState({ status: '' }, this.showWarning(error.message));
		});
	}

	handleRowEdit = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/alerts/' + event.target.closest("tr").id);
	}

		handleRowView = (event) => {
		event.preventDefault();
		this.props.history.push('/tenantAdmin/alertsView/' + event.target.closest("tr").id);
	}

	// Delete methods
	handleDeleteAlert = () => {
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alertDelete", { alertId: this.state.selectedId, filterText: this.state.filterText, statusType: this.state.statusType  }, { withCredentials: true })
				.then((response) => {
					this.setState({ status: '', filteredList: response.data.content.alerts },  this.showAlert(response.data.message));
				}, (error) => {
					this.setState({ status: '' }, this.showWarning(error.message));
				});

			this.props.history.push('/tenantAdmin/alerts');
		}
	}

	showDeleteConfirmation = (event) => {
		let selectedId =  event.target.closest("tr").id;
		let selectedAlertName = event.target.closest("tr").getAttribute("name");
	
		this.setState({
			selectedId,
			selectedAlertName,
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}
	// Delete methods - End


	// Activate/deactivate methods
	
	handleChangeAlertStatus = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		this.setState({ selectedId}, () => this.submitAlertStatus());
	}
	
	submitAlertStatus = () => {
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alertChangeStatusList", { alertId: this.state.selectedId, filterText: this.state.filterText, statusType: this.state.statusType }, { withCredentials: true })
				.then((response) => {
					this.setState({ status: '', filteredList: response.data.content.alerts }, this.showAlert(response.data.message));
				}, (error) => {
					this.setState({ status: '' }, this.showWarning(error.message));
				});
		}
	}

	//  Activate/deactivate methods - End

	exportData = (event) => {
		event.preventDefault();
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "tenantAdmin/alertExport", { filterText: this.state.filterText, statusType: this.state.statusType }, { responseType: 'arraybuffer', withCredentials: true })
				.then((response) => {
					let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
					saveAs(blob, 'alerts.xlsx');
					this.setState({ status: '' })
				}, (error) => {
					this.setState({ status: '' }, this.showAlert(error.message));
				});	
		}
	}

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }

	showWarning = (alertMessage) => {
		this.setState({
		  alertType: ALERT_TYPES.WARNING,
		  showAlert: true,
		  alertMessage
		})
	}
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK
		}, this.props.history.push('/tenantAdmin/alerts'))
	}

	componentDidMount() {
		this.props.setSelectedTenantAdminType();
		this.handleFilter();
	}

	render() {

		let formTemplateMarginLeft = 60
		if (this.props.sideNavigationOpen) {
		  formTemplateMarginLeft = 270
		}
		
		let buttons = [{ label: 'Export', onClickAction: this.exportData, className: 'btn btn-secondary' }]

		const selectFilterProps = {
			selectFilter: this.handleSelectFilter,
			options: [{code: "ALL", description: "All Alerts"}, {code: "A", description: "Active Only"},{code: "I", description: "Inactive Only"}, {code: "P", description: "Pending Only"} ],
			selected: this.state.statusType
		}

		const textFilterProps = {
			textFilter: this.handleTextFilter,
			textFilterReset: this.handleTextFilterReset,
			filterText: this.state.filterText
		}

		const emailAddressFinderFilterProps = {
			finderFilterClick: this.handleEmailAddressFinderFilterClick,
			finderFilterReset: this.handleEmailAddressFinderFilterReset,
			name: this.state.emailAddressName,
			id: this.state.emailAddressId
		}

		const phoneNumberFinderFilterProps = {
			finderFilterClick: this.handlePhoneNumberFinderFilterClick,
			finderFilterReset: this.handlePhoneNumberFinderFilterReset,
			name: this.state.phoneNumberName,
			id: this.state.phoneNumberId
		}

		const userFinderFilterProps = {
			finderFilterClick: this.handleUserFinderFilterClick,
			finderFilterReset: this.handleUserFinderFilterReset,
			name: this.state.userName,
			id: this.state.userId
		}

		const numberOfVisibleRecords = 10;
		let numberOfPages = Math.ceil ( this.state.filteredList.length / numberOfVisibleRecords );
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, this.state.filteredList, numberOfVisibleRecords);

		return (
			<div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)"  }}>
				{ 	
					(this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'TENANT') &&
					<PageBanner pageHeading='Alerts' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps}  finderFilterProps={emailAddressFinderFilterProps} finderFilterProps2={phoneNumberFinderFilterProps} finderFilterProps3={userFinderFilterProps}  buttons={buttons} />
				}
				{ 	
					(this.props.role !== 'FOREVER' && this.props.role !== 'TRIMIN' && this.props.role !== 'TENANT') &&
					<PageBanner pageHeading='Alerts' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps} buttons={buttons} />
				}
				<Container fluid="true">
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0, marginTop: 20, marginLeft: 20,  marginRight: 20, border: '3px solid darkGray', borderRadius: '5px' }}>
							<Table striped hover size="sm" >
								<thead>
									<tr>
										<th style={{width:'20%'}} scope="col">Name</th>
										<th style={{width:'20%'}} scope="col">Username</th>
										<th style={{width:'8%'}} scope="col">Type</th>
										<th style={{width:'27%'}} scope="col">Key</th>
										<th style={{width:'25%'}} scope="col"></th>
									</tr>
								</thead>

								<tbody>
									{
										paginationHelper.currentPageRecordList.map((alertResult) => {
											let inactiveBadge = '';
											if ( alertResult.statusType === 'I') {
												inactiveBadge = "inactive";
											} 
											return (
												<tr style={{ cursor: "pointer" }} id={alertResult.id} name={alertResult.name}  onClick={this.handleRowClick}>
													<td>{alertResult.name}<span className='badge badge-light'>{inactiveBadge}</span></td>
													<td>{alertResult.username ? alertResult.username : 'N/A (migrated)' } </td>
													<td>{alertResult.criteriaType}</td>
													<td>{alertResult.criteria}</td>
													<td style={{ float: 'right' }}>
														{
															alertResult.username &&
															<><Button variant="primary" size='sm' onClick={this.handleRowEdit}>Edit</Button>&nbsp;</>
														}
														{
															!alertResult.username &&
															<><Button variant="primary" size='sm' onClick={this.handleRowView}>View</Button>&nbsp;</>
														}
														{
															alertResult.statusType === 'A' &&
															<><Button variant="danger" size='sm' onClick={this.handleChangeAlertStatus}>Deactivate</Button>&nbsp;</>
														}	
														{
															alertResult.statusType !== 'A' &&
															<><Button variant="secondary" size='sm' onClick={this.handleChangeAlertStatus}>&nbsp;&nbsp;Activate&nbsp;&nbsp;</Button>&nbsp;</>
														}
														<Button variant="danger" size='sm' onClick={this.showDeleteConfirmation} >Delete</Button>
													</td>
												</tr>
											)
										})
									}
								</tbody>
							</Table>
						</Col>
					</Row>
					<Row>&nbsp;</Row>
					<Row>
						<Col style={{marginLeft: 4}}>Displaying Results: {paginationHelper.currentPageStartingRecordNumber}-{paginationHelper.currentPageEndingRecordNumber} of {this.state.filteredList.length}</Col>
						<Col><Paginator style={{justifyContent: 'center'}} componentName={AlertListTenantAdminComponetName} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></Paginator></Col>
					</Row>
				</Container>
				
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteAlert} question={'Delete Alert ' + this.state.selectedAlertName+ '?'} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
				<EmailAddressSelectionList showModal={this.state.showEmailAddressList}  onHide={(selectedId, selectedName) => this.handleCloseEmailAddressLookup(selectedId, selectedName)} />
				<PhoneNumberSelectionList showModal={this.state.showPhoneNumberList}  onHide={(selectedId, selectedName) => this.handleClosePhoneNumberLookup(selectedId, selectedName)} />
				<UserSelectionList showModal={this.state.showUserList} codeDescriptionResults={this.props.users} onHide={(selectedId, selectedName) => this.handleCloseUserLookup(selectedId, selectedName)} />

			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertList);